import React from 'react';
import HubScreen from './HubScreen';
import Dispatch from './Dispatch';
import NotificationsCentre from './NotificationsCentre';
import TelegramScreen from './Telegram';

const TABS = [
  { id: 'chat', label: 'Team Chat', Component: Dispatch },
  { id: 'notifications', label: 'Notifications', Component: NotificationsCentre },
  { id: 'telegram', label: 'Telegram', Component: TelegramScreen },
];

export default function TeamHub(props) {
  return <HubScreen tabs={TABS} hubId="team" passProps={props} />;
}
